export const MASK = [
    /[-\d]/,
    ...new Array(10).fill(/\d/),
];
